import React, { Component } from 'react';
import moment from 'moment';
import { Input, Form, Row, Col, Modal, message, Button, DatePicker, Upload, Icon } from 'antd';
import { Message } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import { localStorageClient } from '../../../../../utils/localStorageClient';

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const DATE_FORMAT = 'DD-MMM-YYYY';

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

class AddOrEditGroupCompanyRegisterModalDialog extends Component {
    componentDidUpdate() {
        const {
            submitAddGroupCompanyRegisterStatus,
            submitUpdateGroupCompanyRegisterStatus,
        } = this.props;

        if (submitAddGroupCompanyRegisterStatus === ACTION_STATUS.SUCCESS) {
            const successMessage = this.props.groupCompanyRegisterModal.mode === 'COPY'
                ? 'Copy Group Company Register succeeded'
                : 'Add Group Company Register succeeded';
            message.success(successMessage);
            this.props.initSubmitAddGroupCompanyRegisterActionStatus();
            this.props.resetAddOrEditGroupCompanyRegisterModal();
            this.props.queryGroupCompanyRegister();
        }
        if (submitAddGroupCompanyRegisterStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitAddGroupCompanyRegisterActionStatus();
        }

        if (submitUpdateGroupCompanyRegisterStatus === ACTION_STATUS.SUCCESS) {
            message.success('Edit Group Company Register succeeded');
            this.props.initSubmitUpdateGroupCompanyRegisterActionStatus();
            this.props.resetAddOrEditGroupCompanyRegisterModal();
            this.props.queryGroupCompanyRegister();
        }
        if (submitUpdateGroupCompanyRegisterStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitUpdateGroupCompanyRegisterActionStatus();
        }
    }

    onInputChange = ({ name, value }) => {
        this.props.addOrEditGroupCompanyRegisterChangeInput({ name, value });
    }

    attachmentUploadChange = info => {
        let fileList = [...info.fileList];
        if (!fileList || fileList.length === 0) {
            this.onInputChange({ name: 'attachmentFileList', value: [] });
            this.onInputChange({ name: 'attachment', value: undefined });
            this.onInputChange({ name: 'attachmentOriginName', value: undefined });
            return;
        }

        fileList = fileList.slice(-1);
        const file = fileList[0];
        this.onInputChange({ name: 'attachmentFileList', value: fileList });

        if (!!file && !!file.response && !!file.response.data) {
            const filename = file.response.data.fileNameWithTimeStamp;
            const originalFileName = file.response.data.originalFileName;
            this.onInputChange({ name: 'attachment', value: filename });
            this.onInputChange({ name: 'attachmentOriginName', value: originalFileName });
        } else if (!!file && !!file.response) {
            this.onInputChange({ name: 'attachment', value: undefined });
            this.onInputChange({ name: 'attachmentOriginName', value: undefined });
            file.status = 'error';
            const errMsg = !!file.response.respMessage ? file.response.respMessage : 'Upload Failed';
            file.response = errMsg;
            message.error(errMsg);
        }
    }

    getModalTitle() {
        const { mode } = this.props.groupCompanyRegisterModal;
        if (mode === 'ADD') {
            return 'Add Group Company Register';
        }
        if (mode === 'COPY') {
            return 'Copy Group Company Register';
        }
        return 'Edit Group Company Register';
    }

    getSubmitLoading = () => {
        const { mode } = this.props.groupCompanyRegisterModal;
        if (mode === 'ADD' || mode === 'COPY') {
            return this.props.submitAddGroupCompanyRegisterStatus === ACTION_STATUS.LOGINING;
        }
        return this.props.submitUpdateGroupCompanyRegisterStatus === ACTION_STATUS.LOGINING;
    }

    submitAddOrEditGroupCompanyRegister = () => {
        const { mode, fields } = this.props.groupCompanyRegisterModal;

        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const now = moment();
            const payload = {
                id: fields.id,
                companyCode: values.companyCode,
                information: values.information,
                details: values.details,
                effectiveDate: values.effectiveDate ? values.effectiveDate.format('YYYY-MM-DD') : undefined,
                endDate: values.endDate ? values.endDate.format('YYYY-MM-DD') : fields.endDate,
                attachment: fields.attachment,
                attachmentOriginName: fields.attachmentOriginName,
                lastUpdatedBy: localStorageClient.getUserName(),
                lastUpdateTime: now.format('YYYY-MM-DD HH:mm:ss'),
            };

            if (mode === 'ADD' || mode === 'COPY') {
                this.props.submitAddGroupCompanyRegister(payload);
            } else {
                this.props.submitUpdateGroupCompanyRegister(payload);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const groupCompanyRegisterModal = this.props.groupCompanyRegisterModal || { isOpened: false, respErrMsg: '', fields: {} };
        const { isOpened, respErrMsg } = groupCompanyRegisterModal;
        const {
            companyCode,
            information,
            details,
            effectiveDate,
            endDate,
            attachment,
            attachmentOriginName,
            attachmentFileList,
        } = groupCompanyRegisterModal.fields;

        const isSubmitLoading = this.getSubmitLoading();
        const effectiveDateValue = effectiveDate ? moment(effectiveDate) : undefined;
        const endDateValue = endDate ? moment(endDate) : undefined;

        return (
            <div>
                <Modal
                    title={this.getModalTitle()}
                    centered
                    width={900}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetAddOrEditGroupCompanyRegisterModal()}
                    footer={[
                        <Button key='Cancel' onClick={() => this.props.resetAddOrEditGroupCompanyRegisterModal()}>
                            Cancel
                        </Button>,
                        <Button key='Submit' type='primary' loading={isSubmitLoading} onClick={this.submitAddOrEditGroupCompanyRegister}>
                            Submit
                        </Button>,
                    ]}
                >
                    <Form layout='horizontal'>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Company Code'>
                                    {getFieldDecorator('companyCode', {
                                        initialValue: companyCode,
                                        rules: [{ required: true, message: 'Please input Company Code' }],
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'companyCode', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Information'>
                                    {getFieldDecorator('information', {
                                        initialValue: information,
                                        rules: [{ required: true, message: 'Please input Information' }],
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'information', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Effective Date'>
                                    {getFieldDecorator('effectiveDate', {
                                        initialValue: effectiveDateValue,
                                        rules: [{ required: true, message: 'Please select Effective Date' }],
                                    })(
                                        <DatePicker
                                            format={DATE_FORMAT}
                                            style={{ width: 220, marginLeft: 10 }}
                                            onChange={(date, dateString) => this.onInputChange({ name: 'effectiveDate', value: dateString })}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='End Date'>
                                    {getFieldDecorator('endDate', {
                                        initialValue: endDateValue,
                                    })(
                                        <DatePicker
                                            format={DATE_FORMAT}
                                            style={{ width: 220, marginLeft: 10 }}
                                            onChange={(date, dateString) => this.onInputChange({ name: 'endDate', value: dateString })}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Attachment'>
                                    {getFieldDecorator('attachmentOriginName', {
                                        initialValue: attachmentOriginName || attachment,
                                    })(
                                        <Upload
                                            name='attachment'
                                            withCredentials={true}
                                            multiple={false}
                                            fileList={attachmentFileList}
                                            action={this.props.groupCompanyRegisterUploadUrl}
                                            onChange={this.attachmentUploadChange}
                                        >
                                            <Button style={{ width: 220, marginLeft: 10 }}>
                                                <Icon type='upload' />Upload
                                            </Button>
                                        </Upload>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={24}>
                                <FormItem labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} label='Details'>
                                    {getFieldDecorator('details', {
                                        initialValue: details,
                                    })(
                                        <TextArea rows={4} style={{ width: 600, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'details', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>

                    {!!respErrMsg &&
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{respErrMsg}</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }
}

const AddOrEditGroupCompanyRegisterModalDialogForm = Form.create({ name: 'AddOrEditGroupCompanyRegisterModalDialog' })(AddOrEditGroupCompanyRegisterModalDialog);
export default AddOrEditGroupCompanyRegisterModalDialogForm;
